var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a-progress', {
    staticClass: "big-progress",
    attrs: {
      "type": "circle",
      "percent": Math.round(_vm.progress),
      "stroke-color": "#FFE86C",
      "trail-color": "#005149",
      "width": 158
    },
    scopedSlots: _vm._u([{
      key: "format",
      fn: function (percent) {
        return [_c('span', {
          staticStyle: {
            "color": "#005149",
            "font-size": "40px",
            "font-family": "Helvetica Light, sans-serif"
          }
        }, [_vm._v(" " + _vm._s(percent) + " ")]), _c('span', {
          staticStyle: {
            "color": "#005149",
            "font-family": "Helvetica Light, sans-serif",
            "font-size": "12px"
          }
        }, [_vm._v(" % ")])];
      }
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }